import LoaderBuilder from './components/LoaderBuilder';
import { refactorRoute } from './routeConstant';

const congTacXaHoiRoutes = [
    {
        name: 'Default',
        path: refactorRoute.CONG_TAC_XA_HOI_DETAIL,
        component: LoaderBuilder(
            () => import('view/CongTacXaHoiChiTiet/CongTacXaHoiRedirect')
        ),
    },
    {
        name: 'Hanh Chinh',
        path: refactorRoute.CONG_TAC_XA_HOI_DETAIL_HANH_CHINH,
        component: LoaderBuilder(() => import('view/DonorDetail/HanhChinh')),
    },
    {
        name: 'Tham Nguoi Hien',
        path: refactorRoute.CONG_TAC_XA_HOI_DETAIL_THAM_GIA_DINH,
        component: LoaderBuilder(
            () => import('view/CongTacXaHoiChiTiet/ThamNguoiHien')
        ),
    },
    {
        name: 'Dang Ky Luu Tru',
        path: refactorRoute.CONG_TAC_XA_HOI_DETAIL_LUU_TRU,
        component: LoaderBuilder(
            () => import('view/CongTacXaHoiChiTiet/DangKyLuuTru')
        ),
    },
    {
        name: 'Lam Viec Voi Gia Dinh',
        path: refactorRoute.CONG_TAC_XA_HOI_DETAIL_LAM_VIEC_GIA_DINH,
        component: LoaderBuilder(
            () => import('view/CongTacXaHoiChiTiet/LamViecVoiGiaDinh')
        ),
    },
    {
        name: 'Trao Tang Ky Niem Chuong',
        path: refactorRoute.CONG_TAC_XA_HOI_DETAIL_TRAO_TANG,
        component: LoaderBuilder(
            () => import('view/CongTacXaHoiChiTiet/TraoTang')
        ),
    },
    {
        name: 'Tat Toan Vien Phi',
        path: refactorRoute.CONG_TAC_XA_HOI_DETAIL_TAT_TOAN_VIEN_PHI,
        component: LoaderBuilder(
            () => import('view/CongTacXaHoiChiTiet/TatToanVienPhi')
        ),
    },
    {
        name: 'Du Dam Tang',
        path: refactorRoute.CONG_TAC_XA_HOI_DETAIL_DU_DAM_TANG,
        component: LoaderBuilder(
            () => import('view/CongTacXaHoiChiTiet/DuDamTang')
        ),
    },
    {
        name: 'Ve Sinh',
        path: refactorRoute.CONG_TAC_XA_HOI_DETAIL_VE_SINH,
        component: LoaderBuilder(
            () => import('view/CongTacXaHoiChiTiet/VeSinh')
        ),
    },
    {
        name: 'Tham Vieng Gia Dinh',
        path: refactorRoute.CONG_TAC_XA_HOI_DETAIL_THAM_VIENG,
        component: LoaderBuilder(
            () => import('view/CongTacXaHoiChiTiet/ThamVieng')
        ),
    },
    {
        name: 'Cong Xa',
        path: refactorRoute.CONG_TAC_XA_HOI_DETAIL_CONG_XA,
        component: LoaderBuilder(
            () => import('view/CongTacXaHoiChiTiet/CongXa')
        ),
    },
    {
        name: 'Ho Tro Kham Chua Benh',
        path: refactorRoute.CONG_TAC_XA_HOI_DETAIL_KHAM_CHUA_BENH,
        component: LoaderBuilder(
            () => import('view/CongTacXaHoiChiTiet/HoTroKhamChuaBenh')
        ),
    },
    {
        name: 'Ho Tro Van De Khac',
        path: refactorRoute.CONG_TAC_XA_HOI_DETAIL_HO_TRO_VAN_DE_KHAC,
        component: LoaderBuilder(
            () => import('view/CongTacXaHoiChiTiet/HoTroVanDeKhac')
        ),
    },
];

export default congTacXaHoiRoutes;
